module.exports = " <div class=btnshow> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <paco-button type=primary v-on:click.native=share>立即分享</paco-button> <share :active=active v-on:share=type></share> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/ShareView.vue
// module id = 157
// module chunks = 1